export enum UploadFileTranslationKey {
    DRAG_FILE = "dragFile",
    OR = "or",
    CHOOSE_FILE = "chooseFile",
}